import "../CSS/Home.css";
import React, { useEffect, useState } from "react";
import video from "../Videos/mixkit-glodfish-swimming-8498-medium.mp4";

// Components
import NavBlock from "./NavBlock";

export default function Home() {
  const [currentTime, setCurrentTime] = useState(
    localStorage.getItem("videoTime")
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 600px)");
    if (!mq.matches) {
      const vid = document.getElementById("myVideo");
      if (vid) {
        if (currentTime) vid.currentTime = currentTime;
        vid.play();
        const intervalId = setInterval(() => {
          setCurrentTime(vid.currentTime);
          localStorage.setItem("videoTime", vid.currentTime);
        }, 700);
        return () => clearInterval(intervalId);
      }
    }
  }, [currentTime]);

  const isMobile = window.matchMedia("(max-width: 600px)").matches;

  return (
    <div>
      <NavBlock />
      {!isMobile ? (
        <video id="myVideo" src={video} loop autoPlay>
          Your browser does not support HTML5 video.
        </video>
      ) : null}
      <section className="Welcome">
        <div>
          <h1>Welcome to my website</h1>
          <p>
            I&apos;m Nick. I build things, travel, and over-engineer my
            projects. Feel free to look around — my contact info is in the
            resume link in the navigation.
          </p>

          <div className="Welcome__Buttons">
            <a href="/projects" className="primary-btn">
              View projects
          </a>
          </div>
        </div>
      </section>
    </div>
  );
}
